<template>
<div>
  <querytitle>
    <template slot="queryleft">
      <div>年度：</div>
      <div>
        <el-select v-model="YY" placeholder="请选择" @change="getfiletypes()" size="mini">
          <el-option v-for="item in years" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </div>
    </template>
  </querytitle>
  <el-table ref="treetable" v-loading="loading" :data="itemlist" style="width: 100%; margin-bottom: 20px" row-key="TID" border default-expand-all :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" :height="hh" stripe size="mini">
    <el-table-column prop="TNAME" label="名称" width="350"></el-table-column>
    <el-table-column prop="TRANGE" label="范围" width="160"></el-table-column>
    <el-table-column prop="PDATE" label="要求完成时间" width="100"></el-table-column>
    <el-table-column label="实际完成时间" width="140">
      <template slot-scope="scope">
        <span style="color:red" v-if="TimeDiff(scope.row.PDATE,scope.row.SDATE).dd<0">{{scope.row.SDATE}}</span>
        <span style="color:green" v-else>{{scope.row.SDATE}}</span>
      </template>
    </el-table-column>
    <!-- <el-table-column prop="SMNAME" label="对应模块" width="180"></el-table-column> -->
    <el-table-column prop="TDESC" label="描述"></el-table-column>
    <el-table-column label="操作" width="100">
      <template slot-scope="scope">
        <div style="text-align: right">
          <el-button v-if="scope.row.TPID != '0'" @click="gettaskitems(scope.row)" type="success" plain size="mini">查看详情</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
  <el-dialog title="任务详情" :visible.sync="dialogFormVisible" width="80%">
    <querytitle style="border-bottom:1px solid #ccc;font-size:12px;">
      <template slot="queryleft">
        <div style="color:red;">{{currentitem.TNAME}}</div>
        <div>{{currentitem.TDESC}}</div>
      </template>
      <template slot="queryright">
        <div>要求完成时间：</div>
        <div style="color:red;">{{currentitem.PDATE}}</div>
      </template>
    </querytitle>
    <div style="height:600px;overflow:auto;">
      <ul>
        <li v-for="(item,index) in taskitems" :key="index">
          <div :class="item.SDATE ? 'green':'red'">
            <span style="font-weight: bold;">{{item.TINAME}}</span>
          </div>
          <div style="font-size:12px;">
            <div>实际完成时间：<span>{{item.SDATE}}</span></div>
            <div>{{item.TIDESC}}</div>
          </div>
        </li>
      </ul>
    </div>
  </el-dialog>
</div>
</template>

<script>
import querytitle from "@/components/querytitle";
export default {
  components: {
    querytitle
  },
  data() {
    return {
      years: [],
      YY: 2020,
      loading: false,
      itemlist: [],
      hh: 500,
      addflag: 0,
      itemindex: 0,
      currentitem: {},
      dialogFormVisible: false,
      taskitems: [],
    };
  },
  created() {
    this.hh = document.documentElement.clientHeight - 215;
    let that = this;
    that.getyears(function (res) {
      that.years = res;
      if (that.years.length > 0) that.YY = that.years[0];
      that.getfiletypes();
    });
  },
  methods: {
    getfiletypes() {
      const that = this;
      let pars = {
        SID: that.CU.cu.sid,
        YY: that.YY
      }
      that.loading = true;
      that.PostData(
        "Common/GetOtherMethod", {
          methodname: "GetTasksTree1",
          pars: pars
        },
        function (res) {
          that.itemlist = res.data.data;
          that.loading = false;
        },
        function (err) {
          that.loading = false;
        }
      );
    },
    gettaskitems(task) {
      const that = this;
      that.currentitem = task
      that.loading = true;
      that.PostData(
        "Common/GetOtherMethod", {
          methodname: "GetTaskItems",
          pars: task,
        },
        function (res) {
          console.log(res)
          that.loading = false;
          that.taskitems = res.data.data;
          that.dialogFormVisible = true
        },
        function (err) {
          that.loading = false;
          console.log(err)
        }
      );
    },
    getEnum() {
      const that = this;
      that.PostData(
        "Common/GETLIST", {
          objname: "sys_module",
          wheres: [],
        },
        function (res) {
          that.enumlist = res.data.data;
        },
        function (err) {
          console.log(err);
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
ul {
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;

  li {
    line-height: 35px;
    width: 320px;
    font-size: 13px;
    margin: 5px;
    border-radius: 10px;
    padding: 5px;
    text-align: left;
    border: 1px solid #EBEEF5;

    .green {
      color: green;
    }

    .red {
      color: red;
    }
  }
}
</style>
